import { usePageContent, useXcoreUtils } from "@robe/client/xcore-ui";
import { Box, Button, Container, Stack, Typography } from "@xcorejs/ui";
import Layout from "components/Layout";
import Subheader from "components/Layout/Subheader";
import RobeHeading from "design-system/robe/RobeHeading";
import { getRobeProps, RobePage } from "xcore";
import { Error404 } from "xcore/types";

export const getStaticProps = getRobeProps<Error404>(() => ({ pageContent: "error404" }));

const Error: RobePage = () => {
  const { stringify } = useXcoreUtils();
  const { values } = usePageContent<Error404>();

  return (
    <Container flexDirection="column" paddingTop={{ _: "3rem", sm: "5rem" }} paddingBottom={{ _: "6rem", sm: "10rem" }}>
      <Box width="85rem" maxWidth="100%" margin="auto">
        <RobeHeading mb="1rem">{stringify(values.title)}</RobeHeading>
        <Stack direction="column" gap={{ _: "2rem", sm: "3rem" }} align="center">
          <Typography variant="p">{stringify(values.subtitle)}</Typography>
          <Typography variant="lead" textAlign="center">
            {stringify(values.message)}
          </Typography>
          <Box mt="3rem">
            <Button as="a" href="/">
              {stringify(values.buttonText)}
            </Button>
          </Box>
        </Stack>
      </Box>
    </Container>
  );
};

Error.Layout = Layout;
Error.Subheader = Subheader;

export default Error;
